export default "__VITE_ASSET__bfc5f0d3__"